<template>
  <div v-loading.body="loading">
    <el-row class="shop-data">
      <el-col :span="24">
        <div class="card-shadow">
          <!-- <p>
            PC Url:
            <a :herf="shopPcUrl">{{ this.shopPcUrl }}</a>
          </p>-->
          <p>
            {{generateCustomizeString('mobileURL')}}:
            <el-tag style="margin-left: 10px; font-size: 14px;">
              <a :href="shopMobileUrl" target="_blank">{{ this.shopMobileUrl }}</a>
            </el-tag>
            <el-popover placement="bottom" width="600" trigger="click">
              <div style="text-align: center; margin: 0 auto;">
                <canvas id="qrcode" style="width: 100%;" />
              </div>
              <img
                src="/static/img/qrcode.png"
                style="width: 30px; margin-left: 10px; vertical-align: middle;"
                slot="reference"
                @click="createQrcode()"
              />
            </el-popover>
          </p>
          <!-- <p>
            {{generateCustomizeString('mobileNewURL')}}:
            <el-tag style="margin-left: 10px; font-size: 14px;">
              <a :href="shopMobileNewUrl" target="_blank">{{ this.shopMobileNewUrl }}</a>
            </el-tag>
            <el-popover placement="bottom" width="600" trigger="click">
              <div style="text-align: center; margin: 0 auto;">
                <canvas id="qrcode" style="width: 100%;" />
              </div>
              <img
                src="/static/img/qrcode.png"
                style="width: 30px; margin-left: 10px; vertical-align: middle;"
                slot="reference"
                @click="createNewMobileUrlQrcode()"
              />
            </el-popover>
          </p> -->
          <p>
            {{generateCustomizeString('pcURL')}}:
            <el-tag style="margin-left: 10px; font-size: 14px;">
              <a :href="shopPcUrl" target="_blank">{{ this.shopPcUrl }}</a>
            </el-tag>
          </p>
          <p v-if="this.shopCustomizedUrl">
            {{generateCustomizeString('customizedUrl')}}:
            <el-tag style="margin-left: 10px; font-size: 14px;">
              <a :href="shopCustomizedUrl" target="_blank">{{ this.shopCustomizedUrl }}</a>
            </el-tag>
          </p>
          <p>
            {{generateCustomizeString('iemallGuide')}}:
            <el-tag style="margin-left: 10px; font-size: 14px;">
              <a
                :href="iemallGuideUrl"
                target="_blank"
              >{{ this.iemallGuideUrl }}</a>
            </el-tag>
          </p>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="shop-total">
          <div class="shop-total-data" style="margin-bottom: 20px;">
            <p>{{generateCustomizeString('numberOfProducts')}}</p>
            <p class="figure">{{this.goodsCount.total}}</p>
          </div>
          <div class="shop-total-data">
            <p>{{generateCustomizeString('numberOfMembers')}}</p>
            <p class="figure">{{this.membersCount.total}}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div id="app" class="shop-chart">
          <div style="font-size: 16px; font-weight: bold; color: #333; margin-bottom: 20px;">
            {{generateCustomizeString('salesStatistic')}} ( NZD $ )
          </div>
          <ve-line :data="chartData" :settings="chartSettings"></ve-line>
        </div>
      </el-col>
    </el-row>
    <!-- <el-button @click="insertTestData()" style="float: right; margin-bottom: 30px; margin-right:50px;">Import Test Data
    </el-button>-->
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import VeLine from 'v-charts/lib/line'
import QrCodeWithLogo from 'qr-code-with-logo'

export default {
  name: 'Home',
  components: {
    VeLine
  },
  data() {
    return {
      shopLogo: '',
      shopName: '',
      shopPcUrl: '',
      shopMobileUrl: '',
      shopMobileNewUrl: '',
      shopCustomizedUrl: '',
      iemallGuideUrl: '',
      goodsCount: [],
      membersCount: [],
      loading: false,
      chartData: {
        columns: [
          this.generateCustomizeString('date'),
          this.generateCustomizeString('wechatPay'),
          this.generateCustomizeString('alipay'),
          this.generateCustomizeString('creditPay'),
          this.generateCustomizeString('UnionPay'),
          this.generateCustomizeString('offlinePayment'),
          this.generateCustomizeString('polipay'),
          'PayPal'
        ],
        rows: []
      },
      chartSettings: {
        stack: {
          日期: [
            '微信支付',
            '支付宝支付',
            '余额支付',
            '线下支付',
            'PoliPay',
            'PayPal'
          ]
        },
        area: true
      }
    }
  },
  methods: {
    generateCustomizeString,
    fetchShopBasic() {
      if (this.loading) return
      this.loading = true

      request({
        url: '/basic',
        method: 'get'
      })
        .then(response => {
          this.shopName = response.data['display_shop_name']
          this.shopLogo = response.data['shop_logo_url']
          if (process.env.VUE_APP_PC_URL == 'nzmai.com.cn') {
            if (window.location.href.substr(0, 5) == 'https') {
              this.shopPcUrl =
                'https://' +
                this.$store.state.shop.shop_domain_prefix +
                window.location.href.substr(14, 13)
            } else if (window.location.href.substr(0, 5) == 'http:') {
              this.shopPcUrl =
                'https://' +
                this.$store.state.shop.shop_domain_prefix +
                window.location.href.substr(13, 13)
            }
          } else if (process.env.VUE_APP_PC_URL == 'localhost:9529') {
            this.shopPcUrl = 'http://' +
              this.$store.state.shop.shop_domain_prefix +
              '.miepay.xyz'
          } else {
            this.shopPcUrl =
              'http://' +
              this.$store.state.shop.shop_domain_prefix +
              '.miepay.xyz'
          }

          if (process.env.VUE_APP_PC_URL == 'nzmai.com.cn') {
            if (window.location.href.substr(0, 5) == 'https') {
              this.shopMobileUrl =
                'https://m' +
                window.location.href.substr(14, 13) +
                '/m/' +
                this.$store.state.shop.shop_domain_prefix +
                '/home'
              this.shopMobileNewUrl =
                'https://' +
                this.$store.state.shop.shop_domain_prefix +
                window.location.href.substr(14, 13) +
                '/m/home'
            } else if (window.location.href.substr(0, 5) == 'http:') {
              this.shopMobileUrl =
                'https://m' +
                window.location.href.substr(13, 13) +
                '/m/' +
                this.$store.state.shop.shop_domain_prefix +
                '/home'
              this.shopMobileNewUrl =
                'https://' +
                this.$store.state.shop.shop_domain_prefix +
                window.location.href.substr(13, 13) +
                '/m/home'
            }
          } else if (process.env.VUE_APP_PC_URL == 'localhost:9529') {
            this.shopMobileUrl = 'http://localhost:8080/m/' +
              this.$store.state.shop.shop_domain_prefix +
              '/home'
            this.shopMobileNewUrl =
              'http://' +
              this.$store.state.shop.shop_domain_prefix +
              '.miepay.xyz/m/home'
          } else {
            this.shopMobileUrl =
              process.env.VUE_APP_MOBILE_URL +
              this.$store.state.shop.shop_domain_prefix +
              '/home'
            this.shopMobileNewUrl =
              'http://' +
              this.$store.state.shop.shop_domain_prefix +
              '.miepay.xyz/m/home'
          }

          if (response.data.shop_custom_host) {
            if (response.data['shop_custom_host'].substr(0, 4) !== 'http') {
              this.shopCustomizedUrl = 'https://' + response.data['shop_custom_host']
            } else {
              this.shopCustomizedUrl = response.data['shop_custom_host']
            }
          }

          if (process.env.VUE_APP_PC_URL == 'nzmai.com.cn') {
            if (window.location.href.substr(0, 5) == 'https') {
              this.iemallGuideUrl =
                'https://guide' +
                window.location.href.substr(14, 13)
            } else if (window.location.href.substr(0, 5) == 'http:') {
              this.iemallGuideUrl =
                'https://guide' +
                window.location.href.substr(13, 13)
            }
          } else {
            this.iemallGuideUrl =
              'https://guide.nzmai.com.cn'
          }
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    insertTestData() {
      if (this.loading) return
      this.loading = true

      request({
        url: '/debug/import',
        method: 'post'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: 'Importing Shop Data Succeeded.',
              type: 'success'
            })
          } else {
            this.$message.error('Importing Shop Data failed.')
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('Importing Shop Data failed.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchGoods() {
      request({
        url: '/goods-list',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            data[i] = obj
          }
          this.goodsCount = meta
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchMembers() {
      request({
        url: '/customer-list',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            data[i] = obj
          }
          this.membersCount = meta
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchDataDetails(page) {
      request({
        url: '/stat/history',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize,
          unit: 4,
          ...this.filters
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.dataDetails = data
          this.chartData.rows = []
          for (var i = 0; i < this.dataDetails.length; i++) {
            var obj = {}
            obj[this.generateCustomizeString('date')] = this.dataDetails[i].stat_date.substr(0, 10)
            obj[this.generateCustomizeString('wechatPay')] = this.dataDetails[i].wechat_amount / 100
            obj[this.generateCustomizeString('alipay')] = this.dataDetails[i].alipay_amount / 100
            obj[this.generateCustomizeString('creditPay')] = this.dataDetails[i].balance_pay_amount / 100
            obj[this.generateCustomizeString('UnionPay')] = this.dataDetails[i].union_amount / 100
            obj[this.generateCustomizeString('offlinePayment')] = this.dataDetails[i].offline_pay_amount / 100
            obj[this.generateCustomizeString('polipay')] = this.dataDetails[i].polipay_amount / 100
            obj['PayPal'] = this.dataDetails[i].paypal_amount / 100
            this.chartData.rows.push(obj)
          }
          this.chartData.rows.reverse()
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
    },
    createQrcode() {
      QrCodeWithLogo.toCanvas({
        canvas: document.getElementById('qrcode'),
        content: this.shopMobileUrl,
        width: 600,
        logo: {
          src: this.shopLogo + '?imageView2/0/w/200/h/200/q/90|imageslim',
          borderRadius: 5
        }
      })
    },
    createNewMobileUrlQrcode() {
      QrCodeWithLogo.toCanvas({
        canvas: document.getElementById('qrcode'),
        content: this.shopMobileNewUrl,
        width: 600,
        logo: {
          src: this.shopLogo + '?imageView2/0/w/200/h/200/q/90|imageslim',
          borderRadius: 5
        }
      })
    }
  },
  created: function() {
    this.fetchShopBasic()
    this.insertTestData()
    this.fetchGoods()
    this.fetchMembers()
    this.fetchDataDetails(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  font-size: 50px;
  font-weight: 400;
  color: #000;
  margin: 0px auto 40px auto;
  text-align: center;
  font-weight: bold;
}
.shop-data {
  padding: 80px 50px;
}
.shop-total {
  margin-right: 30px;
  height: 460px;
}
.shop-total-data {
  padding: 20px 30px;
  height: 220px;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
.shop-chart {
  padding: 40px 30px;
  height: 460px;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
.shop-total-data p {
  font-size: 27px;
  font-weight: 400;
  color: #304155;
  text-align: center;
}
.shop-total-data .figure {
  font-size: 35px;
  font-weight: bold;
}

ul li {
  word-break: keep-all;
}
.el-dialog__header {
    padding-top: 20px !important;
    text-align: center !important;
}
</style>
